import { Box, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { a11yProps, CustomTabPanel } from "../../components/TabPanels";
import { useNavigate } from "react-router-dom";

// assets
import Add from "../../assets/add.svg";

// coomponents
import DisplayList from "../../components/DisplayList";
import CompanyGeneralSettings from "./CompanyGeneralSettings";

import { dbDataStore, userStore } from "../../store/Store";
import Loading from "../../components/Loading";
import ErrorDisplay from "../../components/ErrorDisplay";


export default function CompanySettingsTabs() {
  // global
  const currentCompany = userStore((data) => data.currentCompany);
  const JwtToken = userStore((data) => data.JwtToken);
  const companyLists = dbDataStore((data) => data.companyLists);
  const setCompanyLists = dbDataStore((data) => data.setCompanyLists);
  // local
  const [value, setValue] = useState(0);
  const [listTrigger, setListTrigger] = useState(false)
  const [error, setError] = useState(null)
  const [status, setStatus] = useState('')
  const [pending, setPending] = useState(false)
  const navigate = useNavigate()

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };
  
  // const {error} = useGetFetch(`${process.env.REACT_APP_BACKEND}/pc/company-lists`, setCompanyLists)
  useEffect(() => {
    if (currentCompany.full_access) {
      setPending(true)
      const headers = new Headers()
      const controller = new AbortController()
      headers.append("Content-Type", "application/json")
      headers.append("Authorization", "Bearer " + JwtToken)

      const requestOptions = {
        method: "GET",
        headers,
        signal: controller.signal
      }

      fetch(`${process.env.REACT_APP_BACKEND}/pc/company-lists`, requestOptions)
      .then(res => {
        if (!res.ok) {
          if (res.status === 401) {
            navigate('/login')
            return
          }  else {
          setError("Something Went Wrong")
          setPending(false)
          setStatus(res.status)
          return Promise.resolve()
        }
        } else {
          return res.json()
        }
      })
      .then(data => {
        if (!data) {
          return
        } else {
          setPending(false)
          setCompanyLists(data)
        }
      })
      .catch(err => {
        console.log(err)
        setPending(false)
        setError(err)
        return
      })
      .finally(() => setPending(false))
      return (() => controller.abort())
    }
  }, [JwtToken, currentCompany, setError, setPending, setStatus, setCompanyLists, navigate])

  if (pending) {
    return <Loading />
  }
  if (error) {
    return <ErrorDisplay message={error} code={status} />
  }
  return (
    <>
      <Box
        sx={{
          width: "100%",
          margin: "20px 0 0 0",
          padding: "0",
        }}
      >
        <div className="d-flex justify-content-between project-header">
          <Box sx={{ padding: "0" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                label="General"
                {...a11yProps(1)}
                sx={{
                  fontWeight: "bold",
                  fontSize: "1rem",
                }}
              />
              {currentCompany.full_access && (
                <Tab
                  label="Lists"
                  {...a11yProps(0)}
                  sx={{
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                />
              )}
            </Tabs>
          </Box>
          {(value === 1 && currentCompany.full_access) && (
            <img
              src={Add}
              alt="add"
              className="project-delete-image"
              onClick={() => setListTrigger(true)}
            />
          )}
        </div>
        {currentCompany.full_access && (
          <>
            <CustomTabPanel value={value} index={0}>
              <CompanyGeneralSettings />
            </CustomTabPanel>
            {currentCompany.full_access && (
              <CustomTabPanel value={value} index={1}>
                <DisplayList 
                coll={'Company Lists'}
                docs={companyLists}
                err={error}
                trigger={listTrigger}
                setTrigger={setListTrigger}
                url={`${process.env.REACT_APP_BACKEND}/pc/company-lists`}
                setState={setCompanyLists}
                doNotDisplayTitle={true}
                setDeleteState={setCompanyLists}
              />
              </CustomTabPanel>
            )}
          </>
        )}
      </Box>
    </>
  );
}
